import React from 'react';

import Label from '../Label/Label';
import Select from '../Select/Select';
import Description from '../Description/Description';

import styles from './SelectField.module.css';
import { SettingsFeatureLock } from '../../LockedFeatures/SettingsFeatureLock';

const SelectField = ({
    field,
    options,
    changed,
    disabled,
    type,
    color,
    children,
    multichoice,
    searchable,
    clearable,
    creatable,
    wide,
    tooltip,
    expendDescription,
    onClick,
    featureLockId = undefined,
    featureLockIsTabId = undefined
}) => {
    return (
        <div className={styles.SelectInput}>
            <Label value={field.name} tooltip={tooltip} />
            <div className={styles.fieldsContainer} onClick={onClick}>
                {featureLockId ? (
                    <>
                        <SettingsFeatureLock id={featureLockId} isTabId={!!featureLockIsTabId} className="w-full">
                            <Select
                                {...field}
                                options={options}
                                disabled={disabled}
                                type={type}
                                color={color}
                                changed={changed}
                                multichoice={multichoice}
                                searchable={searchable}
                                clearable={clearable}
                                creatable={creatable}
                                wide={wide}
                            />
                        </SettingsFeatureLock>
                        {children && (
                            <SettingsFeatureLock id={featureLockId ?? field.id} isTabId={!!featureLockIsTabId}>
                                <span className={styles.buttons}>{children}</span>
                            </SettingsFeatureLock>
                        )}
                    </>
                ) : (
                    <>
                        <Select
                            {...field}
                            options={options}
                            disabled={disabled}
                            type={type}
                            color={color}
                            changed={changed}
                            multichoice={multichoice}
                            searchable={searchable}
                            clearable={clearable}
                            creatable={creatable}
                            wide={wide}
                        />{' '}
                        {children && <span className={styles.buttons}>{children}</span>}
                    </>
                )}
            </div>
            {field.desc && <Description value={field.desc} expendDescription={expendDescription} />}
            {field.notification && <div className={styles.notificationText}>{field.notification}</div>}
        </div>
    );
};

export default React.memo(SelectField);
